import { useMemo } from 'react';
import HeatmapOverlay from 'heatmap.js/plugins/leaflet-heatmap/leaflet-heatmap';

import type { WBSequentialMapData } from 'types/Meteorology/Agro/WaterBalanceSequential/Maps/getMapData';
import { WBSequentialMapsConfig } from 'types/Meteorology/Agro/WaterBalanceSequential/Maps/getOptions';

const BASE_CONFIG = {
  // radius should be small ONLY if scaleRadius is true (or small radius is intended)
  // if scaleRadius is false it will be the constant radius used in pixels
  radius: 0.32,
  // opacity at max value
  maxOpacity: 0.95,
  // opacity at min value
  minOpacity: 0.0,
  // scales the radius based on map zoom
  scaleRadius: true,
  // if set to false the heatmap uses the global maximum for colorization
  // if activated: uses the data maximum within the current map boundaries
  //   (there will always be a red spot with useLocalExtremas true)
  useLocalExtrema: false,
  // which field name in your data represents the latitude - default lat
  latField: 'lat',
  // which field name in your data represents the longitude - default lng
  lngField: 'lng',
  // which field name in your data represents the data value - default value
  valueField: 'value',
};

export default function useHeatmapLayer(
  data?: WBSequentialMapData,
  config?: WBSequentialMapsConfig,
) {
  const heatmapLayer = useMemo(() => {
    if (!data || !data.length) return undefined;

    const values = data.map(([,, value]) => value);
    const calculatedMax = Math.max(...values);
    const minValue = Math.min(...values);

    // Usa fixedMax se disponível, senão usa o máximo calculado dos dados
    const maxValue = config?.fixedMax ?? calculatedMax;

    const layerData = {
      max: maxValue,
      min: minValue,
      data: data.map(([lat, lng, value]) => ({ lat, lng, value })),
    };

    const layer = new HeatmapOverlay({ ...BASE_CONFIG, ...config });
    layer.setData(layerData);

    return layer;
  }, [data, config]);

  return heatmapLayer;
}
